import { apiClient } from './client';
import type { AuthUser } from '@/stores/authStore';
import type { Envelope } from './types';

export type UpdateProfileInput = Partial<Pick<AuthUser, 'displayName' | 'locale' | 'theme' | 'units'>>;

export async function updateProfile(input: UpdateProfileInput): Promise<AuthUser> {
  const res = await apiClient.patch<Envelope<AuthUser>>('/users/me', input);
  return res.data.data;
}

export async function deleteAccount(password: string): Promise<void> {
  await apiClient.delete('/users/me', { data: { password } });
}
